export default () => ({
  pathFrom: null,
  goToBasket: false,
  user: null,
  company: null,
  service: null,
  acl: null,
  defaultCostCenter: null,
  minimumValueLimitation: null,
  countOrderForAcceptance: 0,
  otherAccounts: [],
  currentCompany: null,
});
